module.exports = __webpack_public_path__ + "img/dky.bb10d6f9.png";